import type * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { View, type ViewProps } from 'react-native'
import Icon from '~/components/Icon'
import { Text } from '~/components/ui/text'
import { cn } from '~/lib/utils'

const alertVariants = cva('relative w-full rounded-lg border p-4 shadow', {
  variants: {
    variant: {
      default: '',
      destructive: 'border-destructive/60 bg-destructive/40',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

function Alert({
  className,
  variant,
  children,
  iconClassName,
  ...props
}: ViewProps &
  VariantProps<typeof alertVariants> & {
    ref?: React.RefObject<View>
    iconClassName?: string
  }) {
  return (
    <View role="alert" className={cn(alertVariants({ variant, className }), 'pl-12')} {...props}>
      <View className="absolute left-2 top-3">
        <Icon
          size={24}
          name={variant === 'destructive' ? 'alert-circle-outline' : 'information-circle-outline'}
          className={cn(
            'text-foreground',
            variant === 'destructive' && 'text-destructive',
            iconClassName
          )}
        />
      </View>
      {children}
    </View>
  )
}

function AlertTitle({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof Text> & VariantProps<typeof alertVariants>) {
  return (
    <Text
      className={cn(
        'mb-2 font-semibold text-xl leading-none tracking-tight text-foreground',
        variant === 'destructive' && 'text-destructive',
        className
      )}
      {...props}
    />
  )
}

function AlertDescription({
  className,
  ...props
}: React.ComponentProps<typeof Text> & VariantProps<typeof alertVariants>) {
  return (
    <Text
      className={cn(
        'text-base leading-relaxed text-foreground',

        className
      )}
      {...props}
    />
  )
}

export { Alert, AlertDescription, AlertTitle }
